import type { BulkActionAttr } from './types';

export const UPDATE_FORMAT: BulkActionAttr[] = [
  {
    name: 'project_code',
    summary: 'プロジェクトコード',
    example: '123',
    required: true
  },
  {
    name: 'approver',
    summary: '承認者',
    example: 'sato@example.com',
    required: true
  }
];
